module.exports = __webpack_public_path__ + "static/media/ramon-barrera-th.983e9fb1.jpg";